import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import './i18n'; // Import i18n configuration
import Horoscope from './pages/horoscope/Horoscope';
import UserManagement from './pages/admin/UserManagement';
import AdminDashboard from './pages/admin/AdminDashboard';
import Login from './pages/Login';
import { AuthProvider } from './contexts/AuthContext';
import AdminGuard from './components/AdminGuard';
import ContentManagement from './pages/admin/ContentManagement';
import HoroscopeManagement from './pages/admin/HoroscopeManagement';
import ChangePassword from './components/ChangePassword';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import OnBoarding from './pages/OnBoarding';
import Chart from './pages/Chat';
import BirthChartVisualization from './pages/BirthChartVisualization';
import ReadingReport from './pages/ReadingReport';
import SubscriptionManagement from './pages/SubscriptionManagement';
import Welcome from './pages/Welcome';
import Layout from './components/Layout';
import { LanguageProvider } from './contexts/LanguageContext';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/welcome" element={<Layout><Welcome /></Layout>} />
      <Route path="/subscription-management" element={<Layout><SubscriptionManagement /></Layout>} />
      <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
      <Route path="/onboarding" element={<Layout><OnBoarding /></Layout>} />
      <Route path="/chat" element={<Layout><Chart /></Layout>} />
      <Route path="/birth-chart" element={<Layout><BirthChartVisualization /></Layout>} />
      <Route path="/reading-report" element={<Layout><ReadingReport /></Layout>} />
      <Route path="/horoscope" element={<Layout><Horoscope /></Layout>} />
      <Route path="/login" element={<Layout showNavigation={false}><Login /></Layout>} />
      <Route
        path="/users"
        element={
          <Layout>
            <AdminGuard>
              <UserManagement />
            </AdminGuard>
          </Layout>
        }
      />
      <Route
        path="/admin"
        element={
          <Layout>
            <AdminGuard>
              <AdminDashboard />
            </AdminGuard>
          </Layout>
        }
      />
      <Route
        path="/content"
        element={
          <Layout>
            <AdminGuard>
              <ContentManagement />
            </AdminGuard>
          </Layout>
        }
      />
      <Route
        path="/horoscope-management"
        element={
          <Layout>
            <AdminGuard>
              <HoroscopeManagement />
            </AdminGuard>
          </Layout>
        }
      />
      <Route path="/change-password" element={<Layout><ChangePassword /></Layout>} />
      <Route path="/landing-page" element={<Layout><Home /></Layout>} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </LocalizationProvider>
    </LanguageProvider>
  );
};

export default App;
